export default __webpack_public_path__ + "static/media/anonymous-white.5f82ed24.svg";